<template>
  <ModalBase
    :title="title"
    :show="show"
    :override-style="{
      width: 'auto',
      'min-width': '500px',
      height: 'auto',
      'margin-bottom': '0 rem',
      overflow: 'hidden',
    }"
    :override-header-style="{ 'margin-bottom': '1rem' }"
    @closeClicked="onCloseClicked"
  >
    <template #content>
      <div class="error">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="escapedErrorWithLineBreaks" />
      </div>
    </template>
    <template #button-row>
      <div class="actions-row">
        <div class="actions-row-item" @click="copyErrorMessage">
          <div class="actions-row-item-label">{{ $t('content.general.copyErrorMessage') }}</div>
          <GroupIcon class="actions-row-item-icon" />
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from '@/components/shared/modal/ModalBase.vue';
import GroupIcon from '@/assets/images/group.svg';
import { escapeHtml } from '@/helpers/stringHelper';
import { toast } from '@/services/toast';

export default {
  name: 'ContentErrorMessageModal',
  components: {
    ModalBase,
    GroupIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      copying: false,
    };
  },
  computed: {
    escapedErrorWithLineBreaks() {
      const escapedError = escapeHtml(this.errorMessage);
      return `<div>${escapedError.replaceAll('\n', '</div><div>')}</div>`;
    },
  },
  methods: {
    onCloseClicked() {
      if (!this.copying) {
        this.$emit('close');
      }
    },
    async copyErrorMessage() {
      this.copying = true;
      await this.$copyText(this.errorMessage);
      this.onSuccessfullyCopied();
      this.copying = false;
    },
    onSuccessfullyCopied() {
      toast.$emit('showToast', {
        type: 'success',
        message: this.$t('content.general.copiedErrorMessage'),
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/styles/global.scss';

.error {
  @apply .mt-4 .bg-red-100 .border .border-red-400 .text-red-700 .text-left .px-4 .py-3 .rounded .relative;
  word-wrap: anywhere;
  font-family: 'Courier New', 'Courier', monospace !important;
  font-size: rem(12px);
  font-weight: bold;

  & > div {
    padding-left: 1rem;
    text-indent: -1rem;
  }
}

.actions-row {
  height: rem(70px);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: $cch-light-gray;
  margin: rem(31px) rem(-31px) rem(-31px);
  padding: rem(31px);
  width: auto;
  .actions-row-item:first-child {
    margin-right: 4.5rem;
  }
  .actions-row-item:last-child {
    margin-left: 4.5rem;
  }
  .actions-row-item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    max-width: 150px;
    overflow: hidden;

    .actions-row-item-label {
      padding-right: rem(10px);
      font-size: rem(16px);
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: rem(0.53px);
      text-transform: capitalize;
      color: $cch-dark-grey;
    }
    .actions-row-item-icon {
      object-fit: contain;
      align-self: center;
      position: relative;
      margin-bottom: rem(7px);
    }
  }
}
</style>
